import { asyncScriptLoader } from 'ember-simplepractice/utils/async-script-loader';
import { isEmberTesting } from 'ember-simplepractice/utils/is-testing';
import ENV from 'client-portal/config/environment';
import RecaptchaMock from '../mocks/recaptcha-mock';
import Service, { service } from '@ember/service';

export default class RecaptchaService extends Service {
  @service currentPractice;
  @service fastboot;

  get isFastBoot() {
    return this.fastboot?.isFastBoot || typeof window === 'undefined';
  }

  async initialize() {
    if (this.isFastBoot) return;

    await this.#provisionRecaptcha();

    let sitekey = this.currentPractice.get('recaptchaSiteKey');

    if (typeof window?.grecaptcha?.ready === 'function') {
      window.grecaptcha.ready(() => {
        window.grecaptcha.render('recaptcha-container', { sitekey });
      });
    }
  }

  async #provisionRecaptcha() {
    if (!isEmberTesting() && ENV.railsEnv !== 'test') {
      await asyncScriptLoader('https://www.google.com/recaptcha/api.js');
    } else {
      window.grecaptcha = new RecaptchaMock();
    }
  }

  getResponse() {
    if (this.isFastBoot) return null;

    try {
      return window.grecaptcha.getResponse();
    } catch (err) {
      // no op
    }
    return null;
  }

  async reset() {
    if (this.isFastBoot) return;

    try {
      if (typeof window?.grecaptcha?.reset === 'function') {
        window.grecaptcha.reset();
      } else if (!window.grecaptcha) {
        await this.initialize();
      }
    } catch (err) {
      // no op
    }
  }
}
